const heroBase = require('../models/game_state/heroes');
const ItemGenerator = require('../models/game_items/ItemGenerator.js');
const Bag = require('../models/game_items/item_container/Bag');

const generateStarterEquipmentAndBags = (hero_handle) => {
  const starter_equipment = heroBase[hero_handle].getStarterEquipment();
  const starter_equipment_list = Object.values(starter_equipment);
  const starter_bags = [{ value: ItemGenerator.getRandomItem(Bag, 0.1, 0.2) }];
  for (let i = 0; i < starter_bags[0].value.size; ++i) {
    starter_bags[0].value.items[i] = { value: starter_equipment_list[i] || null };
  }

  return { starter_equipment, starter_bags };
};
module.exports = generateStarterEquipmentAndBags;
